import styled from "styled-components";

export const ModalHeaderContainer = styled.div`
  .heading {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 52px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background: linear-gradient(
      to right,
      #3b4baa 0%,
      #9387ca 33%,
      #4b74c0 67%,
      #3b4baa 100%
    );
    padding-top: 0px;

    img {
      max-width: 265px;
      max-height: 30px;
    }
  }
`;
